import { useLocation } from 'react-router-dom';
import { ProviderTopBar } from '../components/layout/provider/ProviderTopBar';
import { ProviderIconRail } from '../components/layout/provider/ProviderIconRail';
import { titleForPath } from '../routes/pathTitles';
import { WorkspaceGate } from './WorkspaceGate';

function cleanTitle(title) {
  return title.replace(/^(?:eVault\s+)?Provider(?:\s+workspace)?\s*[—-]\s*/i, '');
}

export function ProviderShell() {
  const { pathname } = useLocation();
  const { title, subtitle } = titleForPath(pathname);
  const programsRules = pathname.startsWith('/provider/programs-rules');

  return (
    <div className="flex h-screen flex-col bg-eorig-surface pt-3 font-sans text-sm text-eorig-ink">
      <ProviderTopBar />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <ProviderIconRail />
        <main className="min-w-0 flex-1 overflow-y-auto px-4 py-5 sm:px-6 sm:py-6">
          <div className="mx-auto w-full max-w-7xl">
            <WorkspaceGate
              title={cleanTitle(title)}
              subtitle={subtitle}
              headingClassName={programsRules ? 'mb-6' : undefined}
              titleClassName={
                programsRules
                  ? 'text-2xl font-medium tracking-normal text-[#1F2933]'
                  : undefined
              }
              subtitleClassName={
                programsRules
                  ? 'mt-1 max-w-3xl text-xs font-normal leading-4 text-[#5A5A5A]'
                  : undefined
              }
            />
          </div>
        </main>
      </div>
    </div>
  );
}
